import { gameActions } from '../Game/gameSlice';
import { MODIFIER_NAME } from '../Enums/Attributes';
import { DefaultEnums } from '../Enums/GameEnums';
import store, { RootState } from '../store';
import { useAppSelector } from '../redux'
import ImageAsset from '../Components/ImageAsset';
import { returnRandomElementOfArray } from '../helpers/helpers';

export function RewardScreen() {

    const gameState = useAppSelector((state: RootState) => state.game)
    return (
        <div className='reward-container center'>

            {gameState.rewardIndex === 2
                ? <>
                    <div className='text'> Sadly, The Crown is in another level</div>
                    <div className='button-text' onClick={continueGame}> Continue</div>
                </>
                : generateReward(gameState.rewardIndex)
            }
        </div>
    )
}

function continueGame() {
    store.dispatch(gameActions.pickNextLevel());
}

function generateReward(rewardIndex: number) {
    const rewardPool = [0, 1, 2, 3];
    const randomElement = returnRandomElementOfArray(rewardPool);
    const firstReward = randomElement;
    rewardPool.splice(randomElement, 1);
    const secondRandomElement = returnRandomElementOfArray(rewardPool);
    const secondReward = secondRandomElement;
    const rewardNumber = rewardIndex === 0 ? ' first ' : ' second ';
    return (
        <div className='reward-container-picker'>
            <div className='text'> You've killed the boss!</div>
            <ImageAsset name="chest-reward-animated.gif" multiplier={3} />
            <div className='text'> Pick {rewardNumber} reward</div>
            <div className='button-text' onClick={() => addReward(firstReward)}>  +2  {MODIFIER_NAME[firstReward]}</div>
            <div className='button-text' onClick={() => addReward(secondReward)}>  +2  {MODIFIER_NAME[secondReward]}</div>
            {rewardIndex === 0}<div className='text'> You also get {DefaultEnums.GOLD_PER_CHEST} gold coins and {DefaultEnums.HEALTH_POTION_PER_CHEST} potions.</div>
        </div>
    )
}

function addReward(rewardType: MODIFIER_NAME) {
    store.dispatch(gameActions.changeAttributes({ enumValue: rewardType, value: 2 }));
}
